import React, {useState} from 'react'

export default function Locker({onUnlock}) {
    const [input, setInput] = useState('');
    const correctPassword = 'blake2030';
  
    const handleInputChange = (e) => {
      setInput(e.target.value);
    };
  
    const handleUnlock = () => {
      onUnlock(input === correctPassword);
      setInput('');
    };
  
    return (
      <div className="lockscreen-container">
        <h1>Enter Password</h1>
        <input
          type="password"
          value={input}
          onChange={handleInputChange}
          placeholder="•••••••••"
          
        />
        <br/>
        <button onClick={handleUnlock}>Unlock</button>
      </div>
    );
}
